<div class="overdraft-account-users-component">
  <!--
  ########################
  enabled users table
  ########################
  -->
  <div class="row">
    <div class="col"><span class="mat-h3 ml-3">Active Users</span></div>
  </div>
  <div class="row cursor-pointer">
    <div class="col-12">
      @if (loader.loadingEnabledOverdraftUser.inProgress$ | async) {
        <custom-content-loader type="list"></custom-content-loader>
      }
      <div
        [ngClass]="{
          hidden: (loader.loadingEnabledOverdraftUser.inProgress$ | async),
          'table-section': true,
          'pb-3': true
        }"
      >
      <table mat-table
      mat-table
          [dataSource]="enabledUsersDataSource"
          multiTemplateDataRows
          class="width-100 mb-2"
          matSort
          (matSortChange)="onEnabledUsersSort($event)"
      >
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef class="column-width-0"></th>
          <td mat-cell *matCellDef="let element" class="cell cell-padding">
            @if (enabledUsersExpandedElement === element) {
              <span class="mdi mdi-chevron-up"></span>
            }
            @if (enabledUsersExpandedElement !== element) {
              <span class="mdi mdi-chevron-down"></span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="pismoCustomerNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="pismoCustomerNumber"
            class="column-width-1"
          >
            Pismo Customer#
          </th>
          <td mat-cell *matCellDef="let element" class="cell ellipsis">
            {{ element.pismoCustomerNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name" class="column-width-1">
            Name
          </th>
          <td mat-cell *matCellDef="let element">{{ element.Name }}</td>
        </ng-container>
        <ng-container matColumnDef="access">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="access" class="column-width-1">
            Access
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.customerAccessLevel }}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="email" class="column-width-1">
            Email
          </th>
          <td mat-cell *matCellDef="let element">{{ element.Email }}</td>
        </ng-container>
        <ng-container matColumnDef="dob">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="dob" class="column-width-1">DoB</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.dob ? moment(element.dob).format('DD/MM/YYYY') : 'N/A'
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="mobileNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="mobileNumber"
            class="column-width-1"
          >
            Mobile
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.MobileNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="enabledUsersDisplayColumns.length">
            <div class="element-detail" [@detailExpand]="element == enabledUsersExpandedElement ? 'expanded' : 'collapsed'">
              <div class="expanded-details-container">
                <div class="details-section">
                  <div class="details-content">
                    <!-- Layout container for user details and actions side by side -->
                    <div class="details-layout-container">
                      <!-- Left column - User Information -->
                      <div class="details-column details-column-left">
                        <!-- User details -->
                        <div class="section-group">
                          <div class="group-title">
                            <span class="mdi mdi-account-check-outline"></span>
                            User Information
                            
                            <!-- Action buttons moved inline with header -->
                            @if(canAccess){
                              <div class="action-buttons inline">
                                <button
                                  mat-stroked-button
                                  [disabled]="
                                    (loader.loadingEnabledOverdraftUser.inProgress$ | async) ||
                                    (loader.disablingOverdraftUser.inProgress$ | async)
                                  "
                                  (click)="resetPassword(element.Email)"
                                >
                                  <span class="mdi mdi-lock-reset"></span>
                                  Reset Password
                                </button>
                                
                                <button
                                  mat-stroked-button
                                  [disabled]="
                                    (loader.loadingEnabledOverdraftUser.inProgress$ | async) ||
                                    (loader.disablingOverdraftUser.inProgress$ | async)
                                  "
                                  (click)="editPismoCustomer(element)"
                                >
                                  <span class="mdi mdi-account-edit-outline"></span>
                                  Edit Pismo Customer
                                </button>
                                
                                <button
                                  mat-stroked-button
                                  color="warn"
                                  [disabled]="
                                    (loader.loadingEnabledOverdraftUser.inProgress$ | async) ||
                                    (loader.disablingOverdraftUser.inProgress$ | async)
                                  "
                                  (click)="disableUser(element.userId, element.pismoAccountNumber)"
                                >
                                  <span class="mdi mdi-account-cancel-outline"></span>
                                  Disable
                                </button>
                              </div>
                            }
                          </div>
                          
                          <div class="user-info-content">
                            <div class="info-col">
                              <div class="info-row">
                                <span class="info-label">Verified:</span>
                                <span class="info-value">{{ element.verified ? 'Yes' : 'No' }}</span>
                              </div>
                            </div>
                            
                            <!-- Card limits -->
                             @if(loader.loadingEnabledUsersCustomerLimit.inProgress$ | async) {
                              <div class="info-col">
                                    <custom-content-loader type="custom"></custom-content-loader>
                              </div>
                             }
                            @else if(enabledUsersCustomerLimit && enabledUsersCustomerLimit.max_limit) {
                              <div class="info-col">
                                <div class="info-row">
                                  <span class="info-label">Monthly Limit:</span>
                                  <span class="info-value">{{ enabledUsersCustomerLimit.max_limit ? (enabledUsersCustomerLimit.max_limit | currency) : 'N/A' }}</span>
                                  @if(canAccess){
                                    <button mat-icon-button class="edit-button" matTooltip="Update Monthly Limit" (click)="onUpdateMonthlyLimit(element, cardsDataSource.data, enabledUsersCustomerLimit)">
                                      <span class="mdi mdi-square-edit-outline"></span>
                                    </button>
                                  }
                                </div>
                                <div class="info-row">
                                  <span class="info-label">Available Limit:</span>
                                  <span class="info-value">{{ enabledUsersCustomerLimit.available_limit ? (enabledUsersCustomerLimit.available_limit | currency) : 'N/A' }}</span>
                                </div>
                              </div>
                            }
                            @else if(cardsTotalPerUser > 0) {
                              <div class="info-col">
                                <div class="info-row">
                                  <span class="info-label">My Monthly Limit:</span>
                                  <span class="info-value">No limit</span>
                                  @if(canAccess){
                                    <button mat-icon-button class="edit-button" matTooltip="Update Monthly Limit" (click)="onUpdateMonthlyLimit(element, cardsDataSource.data, enabledUsersCustomerLimit)">
                                      <span class="mdi mdi-square-edit-outline"></span>
                                    </button>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>

                        <!-- KYC Verification Section -->
                        @if (element.kycVerificationResult || element.kycStatus) {
                          <div class="section-group kyc-section">
                            <div class="group-title">
                              <span class="mdi mdi-shield-check-outline"></span>
                              KYC Verification
                            </div>
                            <kyc-verification-details
                              [result]="element.kycVerificationResult"
                              [history]="element.kycHistory"
                              [kycStatus]="element.kycStatus"
                              [isExpanded]="isKycVerificationResultExpanded(element)"
                              [showUpdateKycButton]="canAccess"
                              [showFrankieOneButton]="canAccess"
                              [showIssues]="canAccess"
                              (toggleExpand)="toggleKycVerificationResult(element)"
                              (updateKyc)="onUpdateKycVerificationStatus(element)">
                            </kyc-verification-details>
                          </div>
                        }

                        <!-- Cards -->
                        @if(loader.loadingCardDetails.inProgress$ | async){
                          <div class="section-group">
                            <div class="group-title">
                              <span class="mdi mdi-credit-card-outline"></span>
                              Cards
                            </div>
                            <custom-content-loader type="list"></custom-content-loader>
                          </div>
                        } @else {
                          <div class="section-group" *ngIf="cardsTotalPerUser > 0">
                            <div class="group-title">
                              <span class="mdi mdi-credit-card-outline"></span>
                              Cards
                            </div>
                            <div class="cards-container">
                              @for(card of cardsDataSource.data; track card){
                                <div class="card-item">
                                  <div class="card-header">
                                    <span class="card-label">{{ card.printed_name }}</span>
                                    <span class="card-status" [ngClass]="{'status-active': card.status.toLowerCase() === 'active'}">{{ card.status }}</span>
                                  </div>
                                  <div class="card-body">
                                    <div class="card-info">
                                      <span class="info-label">Card spend:</span>
                                      <span class="info-value">{{ card.spending?.spending ?? 0 | currency }}</span>
                                    </div>
                                    <div class="card-info">
                                      <span class="info-label">Card number:</span>
                                      <span class="info-value">•••• {{ card.last_4_digits }}</span>
                                    </div>
                                    <div class="card-info">
                                      <span class="info-label">Expires:</span>
                                      <span class="info-value">{{ card.expiration_date | date: 'MM/yyyy' }}</span>
                                    </div>
                                    @if(canAccess){
                                      <button mat-stroked-button class="card-settings-btn" (click)="openCardsSettings(card)">
                                        <span class="mdi mdi-credit-card-edit-outline"></span>
                                        Settings
                                      </button>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                          
                          <div class="section-group" *ngIf="cardsTotalPerUser === 0">
                            <div class="group-title">
                              <span class="mdi mdi-credit-card-outline"></span>
                              Cards
                            </div>
                            <div class="empty-state">
                              <span class="mdi mdi-card-outline"></span>
                              <p>No cards found</p>
                            </div>
                          </div>
                        }
                      </div>
                      
                      <!-- Remove the right column with actions -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="enabledUsersDisplayColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: enabledUsersDisplayColumns"
            class="cursor-pointer"
            [class.expanded-row]="enabledUsersExpandedElement &&
              enabledUsersExpandedElement === element"
            (click)="onRowClickEnabledUser(element)"></tr>
        <tr class="detail-row"
            [ngClass]="{'detail-row-expanded': enabledUsersExpandedElement &&
              enabledUsersExpandedElement === element}"
            [ngStyle]="{'display': enabledUsersExpandedElement &&
              enabledUsersExpandedElement === element ? null : 'none'}"
            mat-row
            *matRowDef="let element; columns: ['expandedDetail']"></tr>
        </table>
        @if (enabledUsersTotal<1) {
          <table class="width-100">
            <tr>
              <td class="not-found"> No account users found</td>
            </tr>
          </table>
        }
        <div class="ml-3">
          <app-custom-paginator
            [length]="enabledUsersTotal"
            [pageIndex]="enabledUsersOffset"
            [pageSize]="enabledUsersLimit"
            [pageSizeOptions]="[10, 20, 25, 50, 100]"
            (page)="onEnabledUsersPagination($event)"
          >
          </app-custom-paginator>
        </div>
      </div>
    </div>
  </div>

  <!--
  ########################
  disabled users table
  ########################
  -->
  <div class="row separator-top">
    <div class="col"><span class="mat-h3 ml-3">Inactive Users</span></div>
  </div>
  <div class="row cursor-pointer">
    <div class="col-12">
      @if(loader.loadingDisabledOverdraftUser.inProgress$ | async){
        <custom-content-loader
          type="list"
        ></custom-content-loader>
      }
      <div
        [ngClass]="{
          hidden: (loader.loadingDisabledOverdraftUser.inProgress$ | async),
          'table-section': true,
          'pb-3': true
        }"
      >
      <table mat-table
      mat-table
          [dataSource]="disabledUsersDataSource"
          multiTemplateDataRows
          class="width-100 mb-2"
          matSort
          (matSortChange)="onDisabledUsersSort($event)"
      >
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef class="column-width-0"></th>
          <td mat-cell *matCellDef="let element" class="cell cell-padding">
            @if (disabledUsersExpandedElement === element) {
              <span class="mdi mdi-chevron-up"></span>
            }
            @if (disabledUsersExpandedElement !== element) {
              <span class="mdi mdi-chevron-down"></span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="pismoCustomerNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="pismoCustomerNumber"
            class="column-width-1"
          >
            Pismo Customer#
          </th>
          <td mat-cell *matCellDef="let element" class="cell ellipsis">
            {{ element.pismoCustomerNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name" class="column-width-1">
            Name
          </th>
          <td mat-cell *matCellDef="let element">{{ element.Name }}</td>
        </ng-container>
        <ng-container matColumnDef="access">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="access" class="column-width-1">
            Access
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.customerAccessLevel }}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="email" class="column-width-1">
            Email
          </th>
          <td mat-cell *matCellDef="let element">{{ element.Email }}</td>
        </ng-container>
        <ng-container matColumnDef="dob">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="dob" class="column-width-1">DoB</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.dob ? moment(element.dob).format('DD/MM/YYYY') : 'N/A'
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="mobileNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="mobileNumber"
            class="column-width-1"
          >
            Mobile
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.MobileNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="disabledUsersDisplayColumns.length">
            <div class="element-detail" [@detailExpand]="element == disabledUsersExpandedElement ? 'expanded' : 'collapsed'">
              <div class="expanded-details-container">
                <div class="details-section">
                  <div class="details-content">
                    <!-- Layout container for user details and actions side by side -->
                    <div class="details-layout-container">
                      <!-- Left column - User Information -->
                      <div class="details-column details-column-left">
                        <!-- User details -->
                        <div class="section-group">
                          <div class="group-title">
                            <span class="mdi mdi-account-check-outline"></span>
                            User Information
                            
                            <!-- Action buttons moved inline with header -->
                            @if(canAccess){
                              <div class="action-buttons inline">
                                <button
                                  mat-stroked-button
                                  [disabled]="
                                    (loader.loadingEnabledOverdraftUser.inProgress$ | async) ||
                                    (loader.disablingOverdraftUser.inProgress$ | async)
                                  "
                                  (click)="enableUser(element.userId, element.pismoAccountNumber)"
                                >
                                  <span class="mdi mdi-account-outline"></span>
                                  Enable User
                                </button>
                              </div>
                            }
                          </div>
                          
                          <div class="user-info-content">
                            <div class="info-col">
                              <div class="info-row">
                                <span class="info-label">Verified:</span>
                                <span class="info-value">{{ element.verified ? 'Yes' : 'No' }}</span>
                              </div>
                            </div>
                            
                            <!-- Card limits -->
                            @if(loader.loadingCardDetails.inProgress$ | async) {
                              <div class="info-col spend-limits-loading">
                                <div class="info-row">
                                  <span class="info-label">Spend Limits:</span>
                                  <div class="info-value">
                                    <custom-content-loader type="list"></custom-content-loader>
                                  </div>
                                </div>
                              </div>
                            } @else if(cardsTotalPerUser > 0) {
                              <div class="info-col">
                                <div class="info-row">
                                  <span class="info-label">Monthly Limit:</span>
                                  <span class="info-value">{{cardsDataSource.data[0].cardlimit.length > 0 ? cardsDataSource.data[0].cardlimit[0].max_limit : 'N/A'}}</span>
                                </div>
                                <div class="info-row">
                                  <span class="info-label">Available Limit:</span>
                                  <span class="info-value">{{cardsDataSource.data[0].cardlimit.length > 0 ? cardsDataSource.data[0].cardlimit[0].available_limit : 'N/A'}}</span>
                                </div>
                              </div>
                            }
                          </div>
                        </div>

                        <!-- KYC Verification Section -->
                        @if (element.kycVerificationResult || element.kycStatus) {
                          <div class="section-group kyc-section">
                            <div class="group-title">
                              <span class="mdi mdi-shield-check-outline"></span>
                              KYC Verification
                            </div>
                            <kyc-verification-details
                              [result]="element.kycVerificationResult"
                              [history]="element.kycHistory"
                              [kycStatus]="element.kycStatus"
                              [isExpanded]="isKycVerificationResultExpanded(element)"
                              [showUpdateKycButton]="canAccess"
                              [showFrankieOneButton]="canAccess"
                              [showIssues]="canAccess"
                              (toggleExpand)="toggleKycVerificationResult(element)"
                              (updateKyc)="onUpdateKycVerificationStatus(element)">
                            </kyc-verification-details>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="disabledUsersDisplayColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: disabledUsersDisplayColumns"
            class="cursor-pointer"
            [class.expanded-row]="disabledUsersExpandedElement &&
              disabledUsersExpandedElement === element"
            (click)="onRowClickDisabledUser(element)"></tr>
        <tr class="detail-row"
            [ngClass]="{'detail-row-expanded': disabledUsersExpandedElement &&
              disabledUsersExpandedElement === element}"
            [ngStyle]="{'display': disabledUsersExpandedElement &&
              disabledUsersExpandedElement === element ? null : 'none'}"
            mat-row
            *matRowDef="let element; columns: ['expandedDetail']"></tr>
        </table>
        @if (disabledUsersTotal<1) {
          <table class="width-100">
            <tr>
              <td class="not-found"> No account users found</td>
            </tr>
          </table>
        }
       
        <div class="ml-3">
          <app-custom-paginator
            [length]="disabledUsersTotal"
            [pageIndex]="disabledUsersOffset"
            [pageSize]="disabledUsersLimit"
            [pageSizeOptions]="[10, 20, 25, 50, 100]"
            (page)="onDisabledUsersPagination($event)"
          >
          </app-custom-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
